import $ from 'jquery'

var lazyload = function() {

  $('.lazy').find('img').addClass('lazy__img');

  $('.lazy__img').on('load', function() {
    $(this).parent().parent().addClass('loaded')
  }).each(function() {
    if(this.complete) $(this).trigger('load');
  });

}

module.exports = lazyload;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/lazyload.js